export default {
    home: "/scan/queryHome", //首页
    blockList: "/scan/queryBlocksList", //块列表
    txsList: "/scan/queryTransactionList",//用户详情 transaction列表
    blockDetailByNumber: "/scan/queryBlocksByNumber", //根据高度获取块
    blockDetailByHash: "/scan/queryBlocksByHash", //根据hash获取块
    accountDetail:'/scan/queryAccountByAddress',//用户详情 address/index
    txsByHash: "/scan/queryTransactionByHash", //根据hash获取交易
    tokenListAddress:'/scan/queryTokeListByAddress',//用户详情 token交易列表
    transactionEventByHash:'/scan/queryTransactionEventByHash', //根据hash获取事件
    contractList:'/scan/queryContractList',//token ContractList列表
    contractErcList:'/scan/queryTokenListAll',//token Contract ERC20 ERC721列表
    tokenInfo: '/scan/queryTokenInfo',//获取tonken详情
    tokenList: '/scan/queryTokenTransactionList',//获取token交易列表
    tokenHoderList: '/scan/queryTokenHolderList', //获取持币用户列表
    accountList:'/scan/queryAccountList',//account 列表
    internalTnxsList:'/scan/queryInternalTransactionByHash',//token  内部交易
    internalTransAddress:'/scan/queryInternalTransactionByAddress',//account  内部交易
    internalNftInfo:'/scan/queryNftInfo',//account  内部交易
    accountTokenList: "/scan/queryErc20TokenList",//用户详情 TokenList列表
    queryCommitteeList: "/scan/queryCommitteeList",//获取委员会 列表
    queryCommitteeInfoByAddress: "/scan/queryCommitteeInfoByAddress",//获取委员会详情 列表
    queryRewardList: "/scan/queryRewardList",//获取奖励 列表
    queryValidatorVoteList: "/scan/queryValidatorVoteList",//获取投票 列表
    queryVoterRewardList: "/scan/queryVoterRewardList",//获取投票 列表
    queryPocTransactionList: "/scan/queryPocTransactionList",//获取投票详情Transaction 列表
    queryVoterList: "/scan/queryVoterList",//获取Voter 列表
    queryVoterInfo: "/scan/queryVoterInfo",//获取Voter 详情
    queryValidatorData: "/scan//queryValidatorData",//获取validator Epoch ...总值
    queryValidaorVoterAmountList: "/scan/queryValidaorVoterAmountList",
};
